export const kits = {
  title: "Combos",
  createCta: "Crear combo",
  counter_one: "combo",
  counter_other: "combos",
  empty: {
    title: "Crea tu primer combo",
    description:
      "Agrupa productos con descuento y vende más con ofertas atractivas.",
    cta: "Crear combo",
  },
  noProducts: {
    title: "Necesitas al menos 2 productos",
    description:
      "Para crear un combo debes tener mínimo dos productos en tu catálogo.",
    cta: "Crear producto",
  },
  enabledByProductsWarning:
    "Este combo no se puede activar porque alguno de sus productos no está disponible.",
  selector: {
    title: "Selecciona productos",
    description: "Elige entre 2 y 5 productos para armar tu combo.",
    searchPlaceholder: "Buscar productos",
    allCategories: "Todas las categorías",
    continue: "Continuar",
    selectedCount: "{{count}}/{{max}} seleccionados",
    status: {
      variation: "Con variantes",
      inactive: "Inactivo",
      soldOut: "Agotado",
    },
    infoBanner:
      "Los productos con variantes, inactivos o sin stock no se pueden incluir en un combo.",
    emptySearch: "No encontramos productos con esa búsqueda.",
  },
  form: {
    createTitle: "Crear combo",
    editTitle: "Editar combo",
    nameLabel: "Nombre del combo",
    namePlaceholder: "Ej. Combo familiar",
    defaultName: "Nuevo combo",
    productsTitle: "Productos",
    discountTitle: "Descuento",
    discountPercentage: "%",
    discountValue: "$",
    imagesTitle: "Imágenes",
    imagesHint: "Puedes agregar hasta {{max}} imágenes",
    addImage: "Agregar imagen",
    save: "Guardar",
    delete: "Eliminar combo",
    deleteConfirmTitle: "¿Eliminar este combo?",
    deleteConfirmDescription:
      "Esta acción no se puede deshacer. El combo dejará de estar disponible en tu tienda.",
    deleteConfirmCta: "Sí, eliminar",
    deleteCancelCta: "Cancelar",
    priceWithoutDiscount: "Precio sin descuento",
    priceFinal: "Precio final",
    maxQuantityAlert: "Alcanzaste el máximo de unidades para este producto.",
    nameRequired: "El nombre es obligatorio",
    saveSuccessCreate: "Combo creado correctamente",
    saveSuccessUpdate: "Combo actualizado correctamente",
    saveError: "No pudimos guardar el combo. Intenta de nuevo.",
    deleteError: "No pudimos eliminar el combo. Intenta de nuevo.",
    toggleError: "No pudimos actualizar el estado del combo.",
  },
};
